/**
 * @generated SignedSource<<f8ba3c60dce65b361193d4235be9017c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProductRegistrationPaymentStep_Checkout$data = {
  readonly id: string;
  readonly product: {
    readonly organization: {
      readonly viewerActiveMembershipPlan: {
        readonly id: string;
      } | null;
    };
    readonly pricing: {
      readonly " $fragmentSpreads": FragmentRefs<"PaymentFormDiscountSection_Pricing">;
    } | null;
    readonly type: ProductType;
  };
  readonly quote: {
    readonly basePrice: number;
    readonly discount: {
      readonly " $fragmentSpreads": FragmentRefs<"PaymentFormDiscountSection_Discount">;
    } | null;
    readonly finalPrice: number;
  };
  readonly " $fragmentType": "ProductRegistrationPaymentStep_Checkout";
};
export type ProductRegistrationPaymentStep_Checkout$key = {
  readonly " $data"?: ProductRegistrationPaymentStep_Checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductRegistrationPaymentStep_Checkout">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductRegistrationPaymentStep_Checkout",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Pricing",
          "kind": "LinkedField",
          "name": "pricing",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PaymentFormDiscountSection_Pricing"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organization",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "viewerActiveMembershipPlan",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CheckoutQuote",
      "kind": "LinkedField",
      "name": "quote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "basePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finalPrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Discount",
          "kind": "LinkedField",
          "name": "discount",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PaymentFormDiscountSection_Discount"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};
})();

(node as any).hash = "e0bee98f756bde6550cb70ecc30e8fe8";

export default node;
